var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"py-3"},[_c('StatsGrowth',{attrs:{"api":_vm.api,"title":_vm.title}}),_c('div',{staticClass:"subtitle-2 my-3"},[_vm._v("New Requests")]),_c('Table',{staticClass:"my-3",attrs:{"items":_vm.items}}),_c('Detail')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }